import { render, staticRenderFns } from "./shippingfee.vue?vue&type=template&id=dff1bf5e&scoped=true&"
import script from "./shippingfee.vue?vue&type=script&lang=js&"
export * from "./shippingfee.vue?vue&type=script&lang=js&"
import style0 from "./shippingfee.vue?vue&type=style&index=0&id=dff1bf5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff1bf5e",
  null
  
)

export default component.exports